module.exports = __webpack_public_path__ + "img/upload-query-compound.f8f51ef5.gif";